import React from "react";

function ClockIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.29167 13.9583C10.9737 13.9583 13.9583 10.9737 13.9583 7.29167C13.9583 3.60967 10.9737 0.625 7.29167 0.625C3.60967 0.625 0.625 3.60967 0.625 7.29167C0.625 10.9737 3.60967 13.9583 7.29167 13.9583Z"
        stroke="white"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path
        d="M7.29395 3.29102V7.29435L10.1203 10.121"
        stroke="white"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ClockIcon;
